// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"13924c8f","628":"76409d54","791":"5d8f0968"}[chunkId] + ".chunk.css";
};